import React, { useState } from 'react';
import homeBanner from '../images/homeBanner.jpg';
import IdentifyClientsIcon from '../images/Identify Clients .svg';
import CheckVerifyLeadsIcon from '../images/Check and Verify Leads.png';
import HelpPickProviderIcon from '../images/Help Pick Finance Provider.png';
import ExpectEarlyDisbursalIcon from '../images/Expect Early Loan Disbursals.png';
import LoanAgentIcon from '../images/Loan Agent_files/agent-11.svg';
import ExBankerIcon from '../images/Ex-Banker_files/bank-59.svg';
import FinancialAnalystIcon from '../images/MUTUAL FUND_files/analyst-1.svg';
import MutualFundIcon from '../images/MUTUAL FUND_files/piggy-bank-26.svg';
import CharteredAgentIcon from '../images/Chartered Agent_files/calculator-117.svg';
import BuilderIcon from '../images/Builder_files/building-11.svg';
import './BecomePartner.css';

const BecomePartner = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    middleName: '',
    lastName: '',
    mobile: '',
    email: '',
    pan: '',
    profession: '',
    state: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const states = [
    'Andaman and Nicobar Islands',
    'Andhra Pradesh',
    'Arunachal Pradesh',
    'Assam',
    'Bihar',
    'Chandigarh',
    'Chhattisgarh',
    'Dadra and Nagar Haveli',
    'Daman and Diu',
    'Delhi',
    'Goa',
    'Gujarat',
    'Haryana',
    'Himachal Pradesh',
    'Jammu and Kashmir',
    'Jharkhand',
    'Karnataka',
    'Kerala',
    'Lakshadweep',
    'Madhya Pradesh',
    'Maharashtra',
    'Manipur',
    'Meghalaya',
    'Mizoram',
    'Nagaland',
    'Odisha',
    'Puducherry',
    'Punjab',
    'Rajasthan',
    'Sikkim',
    'Tamil Nadu',
    'Telangana',
    'Tripura',
    'Uttar Pradesh',
    'Uttarakhand',
    'West Bengal'
  ];
  const professions = [
    'Select Profession',
    'Agriculture/Farmer',
    'Builder',
    'Chartered Accountant',
    'DSA/DST',
    'Ex-banker',
    'Financial Analyst',
    'Financial Consultant',
    'Freelancer',
    'Insurance Advisor',
    'Loan Agent',
    'Mutual Fund Agent',
    'Real Estate Agent/Broker',
    'Tax Consultant',
    'Others'
  ];

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      alert('Thank you for your interest! We will contact you soon.');
      setFormData({
        firstName: '',
        middleName: '',
        lastName: '',
        mobile: '',
        email: '',
        pan: '',
        profession: '',
        state: ''
      });
    }, 2000);
  };

  return (
    <div className="become-partner-page">
      <section className="partner-hero-section">
        <div className="partner-hero-container">
          {/* Left Column - Content */}
          <div className="partner-hero-left" style={{ backgroundImage: `url(${homeBanner})` }}>
            <div className="partner-hero-content">
              <h1 className="partner-hero-title">
                DSA WITH AMPIRE FINANCE
              </h1>
              <p className="partner-hero-description">
                The Indian loan industry is experiencing unprecedented growth, with millions of individuals and businesses seeking financial solutions every year. As a Direct Selling Agent (DSA) with Ampire Finance, you can tap into this vast potential and build a rewarding career in the financial services sector. We offer a comprehensive range of loan products including Loan Against Shares, Business Loan, Loan Against Property, Used Vehicle Loan, and many more.
              </p>
            </div>
          </div>

          {/* Right Column - Partner Registration Form */}
          <div className="partner-hero-right" id="partner-form">
            <div className="partner-form-container">
              <div className="partner-form-header">
                <h2 className="partner-form-title">WE ARE INDIA'S LEADING LOAN PROVIDER</h2>
                <p className="partner-form-subtitle">
                  Earning Opportunity for all existing agents with Ampire Finance Partner Program.
                </p>
              </div>
              
              <form onSubmit={handleSubmit} className="partner-form">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="firstName">FIRST NAME *</label>
                    <input
                      type="text"
                      id="firstName"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="lastName">LAST NAME *</label>
                    <input
                      type="text"
                      id="lastName"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="middleName">MIDDLE NAME</label>
                    <input
                      type="text"
                      id="middleName"
                      name="middleName"
                      value={formData.middleName}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="mobile">MOBILE NUMBER *</label>
                    <input
                      type="tel"
                      id="mobile"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                      placeholder="Enter 10-digit mobile number"
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="email">EMAIL *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter your email address"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="pan">PAN</label>
                    <input
                      type="text"
                      id="pan"
                      name="pan"
                      value={formData.pan}
                      onChange={handleChange}
                      placeholder="Enter PAN number"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="profession">PROFESSION *</label>
                    <select
                      id="profession"
                      name="profession"
                      value={formData.profession}
                      onChange={handleChange}
                      required
                    >
                      {professions.map((prof, index) => (
                        <option key={index} value={prof === 'Select Profession' ? '' : prof}>
                          {prof}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="state">STATE *</label>
                    <select
                      id="state"
                      name="state"
                      value={formData.state}
                      onChange={handleChange}
                      required
                    >
                      <option value="">-</option>
                      {states.map(state => (
                        <option key={state} value={state}>{state}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <button
                  type="submit"
                  className={`partner-submit-btn ${isSubmitting ? 'loading' : ''}`}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Submitting...' : 'SUBMIT'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Who Can Become Partner Section */}
      <section className="who-can-partner-section">
        <div className="container">
          <h2 className="section-title">WHO CAN BECOME A PARTNER WITH AMPIRE FINANCE?</h2>
          <div className="title-underline"></div>
          <p className="section-description">
            Enhance your professional status. Fire up your entrepreneurial instincts and drive into victory! Any person with interpersonal skills and a passion for success can be a part of Ampire Finance.
          </p>
          
          <div className="partner-categories-grid">
            <div className="partner-category-item">
              <div className="category-icon">
                <img src={LoanAgentIcon} alt="Loan Agent" />
              </div>
              <h3 className="category-title">LOAN AGENT</h3>
            </div>
            <div className="partner-category-item">
              <div className="category-icon">
                <img src={ExBankerIcon} alt="Ex-Banker" />
              </div>
              <h3 className="category-title">EX-BANKER</h3>
            </div>
            <div className="partner-category-item">
              <div className="category-icon">
                <img src={FinancialAnalystIcon} alt="Financial Analyst" />
              </div>
              <h3 className="category-title">FINANCIAL ANALYST</h3>
            </div>
            <div className="partner-category-item">
              <div className="category-icon">
                <img src={MutualFundIcon} alt="Mutual Fund" />
              </div>
              <h3 className="category-title">MUTUAL FUND</h3>
            </div>
            <div className="partner-category-item">
              <div className="category-icon">
                <img src={CharteredAgentIcon} alt="Chartered Agent" />
              </div>
              <h3 className="category-title">CHARTERED AGENT</h3>
            </div>
            <div className="partner-category-item">
              <div className="category-icon">
                <img src={BuilderIcon} alt="Builder" />
              </div>
              <h3 className="category-title">BUILDER</h3>
            </div>
          </div>
        </div>
      </section>

      {/* Why Partner Section */}
      <section className="why-partner-section">
        <div className="container">
          <h2 className="section-title">WHY PARTNER WITH AMPIRE FINANCE?</h2>
          <h2 className="section-subtitle">BENEFITS AND PERKS</h2>
          <div className="title-underline"></div>
          <p className="section-description">
            Ampire Finance Private Limited, a one-stop-shop for all types of Loans. The following are the reasons why you should go for Online Loan DSA Registration to partner with Ampire Finance as a Loan DSA Partner:
          </p>
          
          <div className="benefits-list">
            <div className="benefit-list-item">
              <span className="benefit-check">✓</span>
              <span className="benefit-text">Investment Free</span>
            </div>
            <div className="benefit-list-item">
              <span className="benefit-check">✓</span>
              <span className="benefit-text">Instant Pay-outs</span>
            </div>
            <div className="benefit-list-item">
              <span className="benefit-check">✓</span>
              <span className="benefit-text">High Potential Industry</span>
            </div>
            <div className="benefit-list-item">
              <span className="benefit-check">✓</span>
              <span className="benefit-text">Guaranteed Success</span>
            </div>
            <div className="benefit-list-item">
              <span className="benefit-check">✓</span>
              <span className="benefit-text">Channel Partner Recognition</span>
            </div>
            <div className="benefit-list-item">
              <span className="benefit-check">✓</span>
              <span className="benefit-text">Easy Process</span>
            </div>
          </div>
        </div>
      </section>

      {/* Features and Earnings Section */}
      <section className="features-earnings-section">
        <div className="container">
          <h2 className="section-title">FEATURES AND EARNINGS OF DSA PROGRAM</h2>
          <div className="title-underline"></div>
          <p className="section-description">
            In your role as a Ampire Finance Business Partner in our Loan DSA Partner program as a Loan DSA Franchise, you do the following:
          </p>
          
          <div className="features-grid">
            <div className="feature-item">
              <div className="feature-icon-wrapper">
                <img src={IdentifyClientsIcon} alt="Identify Clients" className="feature-image" />
              </div>
              <h3 className="feature-title">IDENTIFY CLIENTS</h3>
            </div>
            
            <div className="feature-item">
              <div className="feature-icon-wrapper">
                <img src={CheckVerifyLeadsIcon} alt="Check and Verify Leads" className="feature-image" />
              </div>
              <h3 className="feature-title">CHECK AND VERIFY LEADS</h3>
            </div>
            
            <div className="feature-item">
              <div className="feature-icon-wrapper">
                <img src={HelpPickProviderIcon} alt="Help Pick Finance Provider" className="feature-image" />
              </div>
              <h3 className="feature-title">HELP PICK FINANCE PROVIDER</h3>
            </div>
            
            <div className="feature-item">
              <div className="feature-icon-wrapper">
                <img src={ExpectEarlyDisbursalIcon} alt="Expect Early Loan Disbursals" className="feature-image" />
              </div>
              <h3 className="feature-title">EXPECT EARLY LOAN DISBURSALS</h3>
            </div>
          </div>
        </div>
      </section>

      {/* Join Us Section */}
      <section className="join-us-section">
        <div className="container">
          <div className="join-us-content">
            <h2 className="join-us-title">JOIN US AS A DSA PARTNER</h2>
            <a href="/contact" className="join-us-btn">Contact Us</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BecomePartner;

